// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__bFM7L","inputDescription":"styles_inputDescription__2Hltt"};